import {Pipe, PipeTransform} from "@angular/core";
import {ProcessType} from "../../store/state/order.state";

@Pipe({
    name: 'processType',
    standalone: false
})
export class ProcessTypePipe implements PipeTransform {

	transform(value: ProcessType): string {
		switch (value) {
			case ProcessType.INITIAL_CERTIFICATION:
				return 'certification';
			case ProcessType.RECERTIFICATION:
				return 'renewal';
			case ProcessType.TRANSFER:
				return 'transfer';
		}

		return null;
	}
}
